import { render, staticRenderFns } from "./AgentDetail.vue?vue&type=template&id=e34c047e&scoped=true&"
import script from "./AgentDetail.vue?vue&type=script&lang=js&"
export * from "./AgentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AgentDetail.vue?vue&type=style&index=0&id=e34c047e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34c047e",
  null
  
)

export default component.exports